/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { isGuestLoggedIn } from 'sarsaparilla/auth';

import { useAuthState } from 'shared-ui/auth';

/**
 * useUserName returns the signed-in user's display name, e.g. "John D.", or "Guest" for a
 * guest session.
 */
export function useUserName() {
    const { account } = useAuthState();

    if (isGuestLoggedIn()) {
        return 'Guest';
    }

    const rawFirstName = account?.first_name;
    if (!rawFirstName) return undefined;

    const capitalizedFirstName =
        rawFirstName.charAt(0).toUpperCase() + rawFirstName.slice(1);
    const lastInitial = account?.last_name?.[0]
        ? `${account.last_name[0].toUpperCase()}.`
        : '';
    return `${capitalizedFirstName.trim()} ${lastInitial}`.trim();
}
